import { Sidebar } from './Sidebar.js';

export function renderLayout(root) {
  root.innerHTML = `
    <div class="min-h-screen flex flex-col lg:flex-row">
      ${Sidebar()}
      <main id="view"
            class="flex-1 min-w-0 px-5 sm:px-8 lg:px-12 py-8 lg:py-12
                   max-w-6xl mx-auto w-full"></main>
    </div>
  `;
}
